const CARDS = [
  {
    title: '某女星深夜发文疑似回应劈腿传闻',
    category: '明星八卦',
    summary: '该女星凌晨发布长文表示"清者自清"，暗示近期劈腿传闻纯属恶意造谣，将采取法律手段维权。',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20glowing%20in%20dark%20room%20with%20social%20media%20post%20silhouette%2C%20warm%20ambient%20lighting%2C%20late%20night%20mood%2C%20editorial%20photography%2C%20soft%20dramatic%20shadows%2C%20no%20text&width=600&height=400&seq=card-01&orientation=landscape',
    date: '3小时前',
    views: '12.8万',
  },
  {
    title: '选秀节目淘汰环节选手泪洒现场',
    category: '综艺爆料',
    summary: '最新一期淘汰赛中，人气选手意外出局，台上泣不成声，导师也红了眼眶，全场观众起立鼓掌。',
    image: 'https://readdy.ai/api/search-image?query=Empty%20spotlight%20stage%20with%20dramatic%20theater%20lighting%2C%20warm%20golden%20spotlight%20beam%2C%20emotional%20atmosphere%2C%20talent%20show%20set%20design%2C%20cinematic%20mood%2C%20no%20people&width=600&height=400&seq=card-02&orientation=landscape',
    date: '6小时前',
    views: '9.6万',
  },
  {
    title: '新晋流量小生疑似恋情曝光',
    category: '恋情曝光',
    summary: '有媒体拍到该小生与一位圈外女性多次同框出行，举止亲密。粉丝群体已分为"祝福派"和"否认派"两派激烈讨论。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20city%20street%20at%20twilight%20with%20warm%20street%20lamps%2C%20soft%20focus%20cinematic%20photography%2C%20intimate%20atmosphere%2C%20editorial%20style%2C%20no%20people%20faces&width=600&height=400&seq=card-03&orientation=landscape',
    date: '9小时前',
    views: '18.3万',
  },
  {
    title: '某大牌导演新片选角内幕曝光',
    category: '影视圈',
    summary: '知情人士爆料该导演新片选角过程暗藏玄机，多位一线演员争抢角色，背后资本角力令人咋舌。',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%20with%20warm%20cinematic%20lighting%2C%20professional%20film%20production%20atmosphere%2C%20behind%20the%20scenes%20mood%2C%20dramatic%20shadows&width=600&height=400&seq=card-04&orientation=landscape',
    date: '11小时前',
    views: '7.2万',
  },
  {
    title: '网红直播带货翻车现场视频流出',
    category: '网红圈',
    summary: '某知名网红在直播带货过程中产品出现严重质量问题，当场被粉丝质疑，场面一度十分尴尬，直播间掉粉数十万。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20setup%20with%20ring%20light%20and%20products%20on%20display%2C%20warm%20studio%20lighting%2C%20ecommerce%20livestream%20aesthetic%2C%20dramatic%20atmosphere&width=600&height=400&seq=card-05&orientation=landscape',
    date: '14小时前',
    views: '22.1万',
  },
  {
    title: '音乐节后台艺人私下互动曝光',
    category: '音乐圈',
    summary: '某大型音乐节后台花絮流出，多位歌手之间的真实互动让网友大呼"太有爱"，也有部分画面引发争议讨论。',
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20backstage%20atmosphere%20with%20colorful%20warm%20lighting%2C%20instruments%20and%20equipment%2C%20festival%20vibe%2C%20creative%20editorial%20photography%2C%20no%20people%20faces&width=600&height=400&seq=card-06&orientation=landscape',
    date: '1天前',
    views: '15.4万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">爆瓜精选</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            全网最热门的明星大瓜视频与吃瓜现场精选，高清在线观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2 whitespace-nowrap">
                  {item.category}
                </span>
                <h3 className="font-heading text-base text-foreground-950 mb-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">
                  {item.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}